import { render, staticRenderFns } from "./CardDataUsage.vue?vue&type=template&id=74a5ddca&scoped=true&"
import script from "./CardDataUsage.vue?vue&type=script&lang=js&"
export * from "./CardDataUsage.vue?vue&type=script&lang=js&"
import style0 from "./CardDataUsage.vue?vue&type=style&index=0&id=74a5ddca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a5ddca",
  null
  
)

export default component.exports